import { useSelector } from 'react-redux';
import { RootState } from 'redux/root';
import { ProductQuestion } from 'static/models/ProductQuestions';

export const useAvailableProductQuestions = (): ProductQuestion[] => {
    return useSelector((state: RootState) => state.availableProductQuestions);
};
